(function () {
  "use strict";

  var FREE_SHIP = 7500; // cents ($75)
  var money = function (c) { return "$" + (c / 100).toFixed(2); };
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  /* ---------------- Cart drawer ---------------- */
  var drawer = $("[data-cart-drawer]");
  var overlay = $("[data-cart-overlay]");
  var itemsEl = $("[data-cart-items]");
  var footEl = $("[data-cart-foot]");

  function lock() { document.body.style.overflow = "hidden"; }
  function unlock() { document.body.style.overflow = ""; }
  function openDrawer() { if (!drawer) return; drawer.classList.add("open"); if (overlay) overlay.classList.add("open"); drawer.setAttribute("aria-hidden", "false"); lock(); }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove("open"); if (overlay) overlay.classList.remove("open"); drawer.setAttribute("aria-hidden", "true"); unlock(); }

  /* ---------------- Side panels (mobile nav + search) ---------------- */
  var pOverlay = $("[data-panel-overlay]");
  var mnav = $("[data-mnav]");
  var srch = $("[data-search]");
  var searchInput = $("[data-search-input]");

  function openPanel(el) { if (!el) return; el.classList.add("open"); if (pOverlay) pOverlay.classList.add("open"); el.setAttribute("aria-hidden", "false"); lock(); }
  function closePanels() {
    [mnav, srch].forEach(function (el) { if (el) { el.classList.remove("open"); el.setAttribute("aria-hidden", "true"); } });
    if (pOverlay) pOverlay.classList.remove("open");
    unlock();
  }

  document.addEventListener("click", function (e) {
    if (e.target.closest("[data-cart-open]")) { e.preventDefault(); fetchCart().then(openDrawer); }
    if (e.target.closest("[data-cart-close]") || e.target.closest("[data-cart-overlay]")) closeDrawer();
    if (e.target.closest("[data-mnav-open]")) { e.preventDefault(); openPanel(mnav); }
    if (e.target.closest("[data-search-open]")) { e.preventDefault(); openPanel(srch); setTimeout(function () { searchInput && searchInput.focus(); }, 250); }
    if (e.target.closest("[data-mnav-close]") || e.target.closest("[data-search-close]") || e.target.closest("[data-panel-overlay]")) closePanels();
  });
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") { closeDrawer(); closePanels(); } });

  /* ---------------- Predictive search ---------------- */
  if (searchInput) {
    var resultsEl = $("[data-search-results]");
    var hintEl = $("[data-search-hint]");
    var timer;
    searchInput.addEventListener("input", function () {
      var q = searchInput.value.trim();
      clearTimeout(timer);
      if (q.length < 2) { resultsEl.innerHTML = ""; if (hintEl) hintEl.textContent = "Start typing to search products"; return; }
      timer = setTimeout(function () {
        var url = "/search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=8";
        fetch(url, { headers: { Accept: "application/json" } })
          .then(function (r) { return r.json(); })
          .then(function (data) {
            var products = (data.resources && data.resources.results && data.resources.results.products) || [];
            if (hintEl) hintEl.textContent = products.length ? products.length + " results" : "No matches for \u201c" + q + "\u201d";
            resultsEl.innerHTML = products.map(function (p) {
              var img = p.featured_image && p.featured_image.url
                ? '<img src="' + p.featured_image.url + '" alt="">'
                : '<span class="ph"><svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.3"><path d="M11 20A7 7 0 0 1 4 13c0-5 7-9 7-9s7 4 7 9a7 7 0 0 1-7 7z"/></svg></span>';
              return '<a class="srch__res" href="' + p.url + '">' + img + "<span><b>" + p.title + "</b>" + (p.price ? "<small>" + p.price + "</small>" : "") + "</span></a>";
            }).join("");
          })
          .catch(function () {});
      }, 220);
    });
  }

  /* ---------------- Render cart ---------------- */
  function renderCart(cart) {
    $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; el.hidden = cart.item_count === 0; });
    if (!itemsEl) return;

    if (!cart.items.length) {
      itemsEl.innerHTML = '<div class="cd__empty"><svg width="42" height="42" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4"><path d="M6 2 3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z"/><path d="M3 6h18M16 10a4 4 0 0 1-8 0"/></svg><p>Your bag is empty.<br>The collection awaits.</p></div>';
      if (footEl) footEl.hidden = true;
      return;
    }

    itemsEl.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + it.image.replace(/(\.[a-z]+)(\?|$)/i, "_120x$1$2") + '" alt="">' : "";
      var variant = (it.product_has_only_default_variant === false && it.options_with_values)
        ? '<p class="cd__var">' + it.options_with_values.map(function (o) { return o.value; }).join(" \u00b7 ") + "</p>" : "";
      return '<div class="cd__item" data-key="' + it.key + '">' +
        '<div class="cd__img">' + img + "</div>" +
        '<div class="cd__info"><p class="cd__name"><a href="' + it.url + '">' + it.product_title + "</a></p>" + variant +
        '<div class="cd__qty"><button type="button" data-change="-1">\u2212</button><span>' + it.quantity + '</span><button type="button" data-change="1">+</button></div><br>' +
        '<button class="cd__rm" data-change="0">Remove</button></div>' +
        '<div class="cd__price">' + money(it.final_line_price) + "</div></div>";
    }).join("");

    if (footEl) {
      footEl.hidden = false;
      var remaining = FREE_SHIP - cart.total_price;
      var pct = Math.max(0, Math.min(100, (cart.total_price / FREE_SHIP) * 100));
      var ship = remaining > 0
        ? '<div class="cd__ship">' + money(remaining) + " from complimentary shipping</div>"
        : '<div class="cd__ship">Complimentary shipping unlocked</div>';
      footEl.innerHTML = ship +
        '<div class="cd__bar"><i style="width:' + pct + '%"></i></div>' +
        '<div class="cd__sub"><span>Subtotal</span><span>' + money(cart.total_price) + "</span></div>" +
        '<div class="cd__total"><span>Total</span><b class="serif">' + money(cart.total_price) + "</b></div>" +
        '<button class="cd__checkout" data-checkout>Proceed to checkout</button>' +
        '<p class="cd__note">' + cart.currency + " \u00b7 Secure checkout</p>";
    }
  }

  function fetchCart() {
    return fetch("/cart.js", { headers: { Accept: "application/json" } })
      .then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); return cart; });
  }

  document.addEventListener("click", function (e) {
    var btn = e.target.closest("[data-change]");
    if (btn && itemsEl && itemsEl.contains(btn)) {
      var row = btn.closest("[data-key]");
      var key = row.getAttribute("data-key");
      var dir = parseInt(btn.getAttribute("data-change"), 10);
      var cur = parseInt(row.querySelector(".cd__qty span").textContent, 10);
      var qty = dir === 0 ? 0 : cur + dir;
      fetch("/cart/change.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: key, quantity: qty }) })
        .then(function (r) { return r.json(); }).then(renderCart);
    }
    if (e.target.closest("[data-checkout]")) window.location.href = "/checkout";
  });

  /* ---------------- Quick add ---------------- */
  document.addEventListener("click", function (e) {
    var add = e.target.closest("[data-add-to-cart]");
    if (!add) return;
    e.preventDefault();
    add.classList.add("done");
    fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: add.getAttribute("data-variant-id"), quantity: 1 }) })
      .then(function () { return fetchCart(); }).then(openDrawer)
      .then(function () { setTimeout(function () { add.classList.remove("done"); }, 1200); });
  });

  /* ---------------- Product gallery ---------------- */
  var mainImg = $("[data-main-img]");
  if (mainImg) {
    $$("[data-thumb]").forEach(function (t) {
      t.addEventListener("click", function () {
        mainImg.src = t.getAttribute("data-full");
        $$("[data-thumb]").forEach(function (x) { x.classList.remove("active"); });
        t.classList.add("active");
      });
    });
  }

  /* ---------------- Product variants ---------------- */
  var pdp = $("[data-product-form]");
  if (pdp) {
    var jsonEl = pdp.querySelector("[data-variant-json]");
    var variants = jsonEl ? JSON.parse(jsonEl.textContent) : [];
    var idInput = pdp.querySelector("[data-variant-id]");
    var priceEl = pdp.querySelector("[data-price]");
    var addBtn = pdp.querySelector("[data-add-btn]");
    var form = pdp.querySelector("form");
    var qtyInput = pdp.querySelector("[data-qty]");

    var selectedOptions = function () {
      var opts = [];
      $$("[data-option-index]:checked", pdp).forEach(function (r) { opts[r.getAttribute("data-option-index") - 1] = r.value; });
      return opts;
    };
    var match = function () {
      var opts = selectedOptions();
      if (!opts.length) return variants[0];
      return variants.find(function (v) { return v.options.every(function (o, i) { return o === opts[i]; }); });
    };
    var updateVariant = function () {
      var v = match(); if (!v) return;
      idInput.value = v.id;
      var price = money(v.price);
      if (v.compare_at_price && v.compare_at_price > v.price) price = "<s>" + money(v.compare_at_price) + "</s> " + price;
      priceEl.innerHTML = price;
      if (addBtn) { addBtn.disabled = !v.available; addBtn.querySelector("span").textContent = v.available ? "Add to bag" : "Sold out"; }
    };
    pdp.addEventListener("change", function (e) { if (e.target.matches("[data-option-index]")) updateVariant(); });

    if (qtyInput) {
      pdp.querySelector("[data-qty-minus]").addEventListener("click", function () { qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1); });
      pdp.querySelector("[data-qty-plus]").addEventListener("click", function () { qtyInput.value = parseInt(qtyInput.value, 10) + 1; });
    }
    if (form) {
      form.addEventListener("submit", function (e) {
        e.preventDefault();
        if (addBtn && addBtn.disabled) return;
        fetch("/cart/add.js", { method: "POST", headers: { "Content-Type": "application/json", Accept: "application/json" }, body: JSON.stringify({ id: idInput.value, quantity: qtyInput ? parseInt(qtyInput.value, 10) : 1 }) })
          .then(function () { return fetchCart(); }).then(openDrawer);
      });
    }
    updateVariant();
  }

  /* ---------------- Scroll reveal ---------------- */
  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.12 });
    $$(".reveal").forEach(function (el) { io.observe(el); });
  } else {
    $$(".reveal").forEach(function (el) { el.classList.add("in"); });
  }

  fetchCart();
})();

/* ================= v3 ELEVATION behaviours ================= */
(function () {
  "use strict";
  var all = function (s) { return Array.prototype.slice.call(document.querySelectorAll(s)); };
  var fine = matchMedia("(pointer:fine)").matches;
  var calm = matchMedia("(prefers-reduced-motion:reduce)").matches;

  /* Header refines on scroll */
  var hdr = document.querySelector(".hdr");
  if (hdr) {
    var onScroll = function () { hdr.classList.toggle("is-scrolled", window.scrollY > 20); };
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
  }

  /* Hero cursor spotlight */
  var hero = document.querySelector(".hero");
  var spot = document.querySelector("[data-hero-spot]");
  if (hero && spot && fine && !calm) {
    hero.addEventListener("mousemove", function (e) {
      var r = hero.getBoundingClientRect();
      spot.style.setProperty("--mx", ((e.clientX - r.left) / r.width * 100) + "%");
      spot.style.setProperty("--my", ((e.clientY - r.top) / r.height * 100) + "%");
    });
  }

  /* Magnetic buttons */
  if (fine && !calm) {
    all(".btn").forEach(function (b) {
      b.addEventListener("mousemove", function (e) {
        var r = b.getBoundingClientRect();
        var x = e.clientX - r.left - r.width / 2;
        var y = e.clientY - r.top - r.height / 2;
        b.style.transform = "translate(" + x * 0.16 + "px," + y * 0.26 + "px)";
      });
      b.addEventListener("mouseleave", function () { b.style.transform = ""; });
    });
  }

  /* Staggered reveals for product grids + tiles */
  all(".grid").forEach(function (grid) {
    Array.prototype.forEach.call(grid.querySelectorAll(".card"), function (card, i) {
      card.classList.add("reveal");
      card.style.transitionDelay = Math.min(i, 8) * 55 + "ms";
    });
  });
  all(".tiles .tile").forEach(function (t, i) { t.style.transitionDelay = Math.min(i, 8) * 70 + "ms"; });

  if ("IntersectionObserver" in window) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add("in"); io.unobserve(en.target); } });
    }, { threshold: 0.08 });
    all(".reveal:not(.in)").forEach(function (el) { io.observe(el); });
  } else {
    all(".reveal").forEach(function (el) { el.classList.add("in"); });
  }
})();

/* Safety: always mark body ready (in case any CSS gates visibility on it) */
(function () {
  var ready = function () { document.body && document.body.classList.add("ready"); };
  if (document.readyState !== "loading") ready();
  else document.addEventListener("DOMContentLoaded", ready);
})();
